<template>
  <div class="ic-info-wrap">
    <div class="ic-info-box">
      <dl>
        <dt>상품구성</dt>
        <dd>
          {{ data.promotionCode == 'KT2408' ? '' : data.speed }}
          {{ data.itemUse }}{{ getPhoneJoin(data.phoneJoin) }}
        </dd>
      </dl>
      <dl v-if="data.promotionCode == 'MY_INTERNET'">
        <dt>요금제</dt>
        <dd v-html="isItemCompose()"></dd>
      </dl>
      <dl class="two">
        <dt>기존통신사</dt>
        <dd>{{ data.currentTelecom || '-' }}</dd>
      </dl>
      <dl class="two">
        <dt>희망통신사</dt>
        <dd v-if="isCustomer" class="two">
          {{ data.telecom ? data.telecom : '-' }}
          <img
            v-if="isPromo"
            :src="require('@/assets/front/images/new/img_tag_promo.svg')"
            alt=""
          />
        </dd>
        <dd v-else>
          {{ data.telecomUse ? data.telecomUse : '-' }}
        </dd>
      </dl>
      <dl>
        <dt>설치지역</dt>
        <dd>{{ data.areaFullName }}{{ getAreaType(data.areaType) }}</dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-ic-user-request-info',
  description: '사용자 인터넷 견적 요청 정보',
  props: {
    data: Object,
    isCustomer: {
      type: Boolean,
      default: true,
    },
    isPromo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      areaTypes: [
        { label: '아파트', value: 'APT' },
        { label: '빌라, 주택 등', value: 'HOUSE' },
        { label: '사무실', value: 'OFFICE' },
        { label: '영업매장', value: 'SHOP' },
      ],
    };
  },
  methods: {
    isItemCompose() {
      let itemCompose = '';

      if (this.data.itemInternet) {
        itemCompose = '[인터넷] ';
        // itemCompose += this.data.speed;
        itemCompose += this.data.itemInternet;
      }

      if (this.data.itemTv) {
        itemCompose += '<br/>';
        itemCompose += '[TV] ';
        itemCompose += this.data.itemTv;
      }

      return itemCompose;
    },
    getAreaType(area) {
      if (!area || area == null) {
        return '';
      }
      const foundInfo = this.areaTypes.filter(info => info.value === area);

      if (foundInfo[0].label) {
        return ' | ' + foundInfo[0].label;
      }
      return '';
    },
    getPhoneJoin(phoneJoin) {
      if (phoneJoin == 'PHONE') {
        return '+휴대폰';
      } else if (phoneJoin == 'USIM') {
        return '+USIM';
      } else {
        return '';
      }
    },
  },
};
</script>

<style></style>
